import * as React from 'react'

import { observer } from 'mobx-react'

import {
  Field,
  FieldError,
  FieldLabel,
} from '~/client/src/shared/components/shadcn-ui/field'
import {
  InputGroup,
  InputGroupInput,
} from '~/client/src/shared/components/shadcn-ui/input-group'

interface IProps {
  id: string
  text: string
  errorMessageText: string
  label: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onButtonClick?: () => void
  isHidden?: boolean
  isErrorVisible?: boolean
  isReadOnly?: boolean
  isNewProjectSelected: boolean
  renderDoneButton(
    clickHandler: () => void,
    isHidden?: boolean,
    isDisabled?: boolean,
  ): JSX.Element
}

const ProjectInputBlock: React.FC<IProps> = observer(
  ({
    id,
    text,
    errorMessageText,
    label,
    onChange,
    onButtonClick,
    isHidden,
    isErrorVisible,
    isReadOnly,
    isNewProjectSelected,
    renderDoneButton,
  }: IProps) => {
    return (
      <div className="tw:flex tw:items-start tw:gap-3 tw:px-[30px] tw:py-2">
        <Field
          className="tw:w-[350px]"
          data-invalid={isErrorVisible || undefined}
        >
          <FieldLabel htmlFor={id}>{label}</FieldLabel>
          <InputGroup>
            <InputGroupInput
              id={id}
              aria-invalid={isErrorVisible || undefined}
              value={text}
              onChange={onChange}
              readOnly={isReadOnly}
              disabled={isReadOnly}
            />
          </InputGroup>
          <FieldError>{isErrorVisible && errorMessageText}</FieldError>
        </Field>
        {!isNewProjectSelected &&
          renderDoneButton(onButtonClick, isHidden, isErrorVisible)}
      </div>
    )
  },
)

export default ProjectInputBlock
